import type { FC, ReactNode } from 'react'

import { ArrowRight } from 'lucide-react'
import { LogoMark } from '@/components/generals/logo'
import { ButtonLink } from '@/components/generals/button'

import { DEMO_HREF } from '@/constants/navigation'

export const ClosingSection: FC = (): ReactNode => {
    return (
        <section id='get-started' aria-labelledby='closing-title' className='px-5 pt-28 pb-4 text-center sm:pt-36'>
            <div className='reveal'>
                <LogoMark draw className='mx-auto size-11 text-foreground' />
            </div>

            <h2 id='closing-title' className='reveal reveal-d1 mt-6 font-heading text-[clamp(2.75rem,5.6vw,4.6rem)] leading-[0.98] tracking-[-0.03em] text-foreground'>
                Hand off the follow-ups.
                <span className='block'>Keep the relationships.</span>
            </h2>

            <p className='reveal reveal-d2 mx-auto mt-6 max-w-[36rem] text-[17px] leading-[1.55] text-muted-foreground sm:text-lg'>
                Whether you are a solo agent, a growing team or a brokerage with a full back office, Closewell takes the reminders, signatures and status updates off your plate. You get to be there for the part that matters: handing over the keys.
            </p>

            <div className='reveal reveal-d3 mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row'>
                <ButtonLink href={DEMO_HREF} size='lg' className='w-full max-w-xs sm:w-auto'>
                    Meet your coordinator
                    <ArrowRight className='size-4 transition-transform duration-300 group-hover:translate-x-1' />
                </ButtonLink>

                <ButtonLink href='/pricing' variant='light' size='lg' className='w-full max-w-xs sm:w-auto'>
                    See pricing
                </ButtonLink>
            </div>
        </section>
    )
}
